<template>
  <el-dialog
    v-model="visible"
    fullscreen
    :append-to-body="true"
    :show-close="false"
    class="member-fullscreen-dialog"
    @close="handleClose"
  >
    <template #header>
      <div class="member-preview-header">
        <img class="ydppt-header-logo" :src="logo" alt="一点PPT Logo" @click="goHome" />
        <button class="preview-action-btn" type="button" @click="close">
          <img :src="headClose" alt="关闭" class="preview-close-img" />
        </button>
      </div>
    </template>

    <MemberContent
      v-if="visible"
      mode="modal"
      :member-type="memberType"
      :select-duration="selectDuration"
      :source="source"
    />
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { ElDialog } from 'element-plus'
import MemberContent from '@/views/yidian/Member/MemberContent.vue'
import logo from '@/assets/images/home/web_logo.png'
import headClose from '@/assets/images/head/head_close.png'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  memberType: {
    type: String,
    default: 'Member'
  },
  selectDuration: {
    type: [Boolean, String],
    default: false
  },
  source: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'close'])
const router = useRouter()

const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const close = () => {
  visible.value = false
}

const handleClose = () => {
  emit('close')
}

const goHome = () => {
  router.push('/')
}
</script>

<style lang="scss" scoped>
.member-preview-header {
  height: 54px;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  position: relative;
  z-index: 1001;
}

.ydppt-header-logo {
  width: 118px;
  height: 32px;
  display: block;
  object-fit: contain;
  cursor: pointer;
  flex-shrink: 0;
}

.preview-action-btn {
  width: 38px;
  height: 38px;
  border: 1px solid rgba(6, 10, 38, 0.06);
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.preview-close-img {
  width: 20px;
  height: 20px;
}
</style>

<style lang="scss">
.member-fullscreen-dialog {
  --el-dialog-padding-primary: 0;

  > .el-dialog__header {
    padding: 0;
    margin: 0;
  }

  > .el-dialog__body {
    padding: 0;
    min-height: calc(100vh - 54px);
    background: #f8f8f8;
  }
}
</style>
